import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo
} from 'react';
import { SavedSearch, SuggestionSelectionProps } from './contracts';

export type SearchBarContextProps = {
  apiBaseUrl: string;
  buttonSize?: 'small' | 'large';
  cdnBaseUrl: string;
  customEventData?: Record<string, any>;
  geolocationState: string;
  inputBgColor?: 'gray' | 'white';
  id?: string;
  onCloseModal?: () => void;
  onFocus?: (isFocused: boolean) => void;
  onShowModalClick?: () => void;
  onSuggestApiError?: (error: unknown) => void;
  onSuggestionSelection?: (props: SuggestionSelectionProps) => void;
  refSource: string;
  rounded?: string;
  savedSearches?: SavedSearch[];
  showButton?: boolean;
  showModal?: boolean;
  trackEvent: (
    _eventName: string,
    _customAttributes?: object | undefined,
    _overrides?: object | undefined,
    _options?:
      | {
          useFetch?: boolean | undefined;
          fetchOption?: RequestInit | undefined;
        }
      | undefined
  ) => void;
};

export type SearchBarContextType = SearchBarContextProps;
const defaultContext: SearchBarContextType = {
  apiBaseUrl: '',
  buttonSize: undefined,
  cdnBaseUrl: '',
  customEventData: {},
  geolocationState: '',
  inputBgColor: undefined,
  onCloseModal: undefined,
  onFocus: undefined,
  onShowModalClick: undefined,
  onSuggestApiError: undefined,
  onSuggestionSelection: undefined,
  refSource: '',
  rounded: undefined,
  savedSearches: undefined,
  showButton: undefined,
  showModal: undefined,
  trackEvent() {}
};

const SearchBarContext = createContext<SearchBarContextType>(defaultContext);

export type OwnProps = PropsWithChildren<SearchBarContextProps>;

export function SearchBarContextProvider({ children, ...props }: OwnProps) {
  const value = useMemo<SearchBarContextType>(
    () => ({
      ...props
    }),
    [props]
  );

  return (
    <SearchBarContext.Provider value={value}>
      {children}
    </SearchBarContext.Provider>
  );
}

export default SearchBarContext;

export function useSearchBarContext() {
  return useContext(SearchBarContext);
}

export function useWillNavigateToSearch() {
  return !Boolean(useSearchBarContext().onSuggestionSelection);
}
